import DataFetcherTemplate from "../../hooks/fetchTemplate";
import { motion } from "framer-motion";
import { ArrowRight, Plus } from "lucide-react";

function OfferEdes() {
  // Helpers simples (sin romper lógica)
  const getValue = (val) => (Array.isArray(val) ? val.join(", ") : val);

  const DataDisplayOferta = ({ data }) => (
    <div className="px-16 md:px-10">
      {/* Grid moderno */}
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4 pt-10">
        {data.map((item, index) => {
          const modalidad =
            item.field_modalidad || item.field_modalidad_carrera;

          const duracion = item.field_duracion || item.field_posgrado_duracion;

          const campo =
            item.field_posgrado_campo || item.field_campo_amplio_del_conocimie;

          return (
            <motion.a
              key={index}
              href={item.field_enlace_contenido}
              rel="noreferrer"
              className="group relative block bg-white rounded-2xl shadow-md overflow-hidden"
              initial="rest"
              animate="rest"
              whileHover="hover"
              whileTap="tap"
            >
              {/* Imagen */}
              <div className="h-40 overflow-hidden">
                <img
                  src={item.field_portada}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
              </div>

              {/* Botón + */}
              <motion.div
                variants={{
                  rest: { scale: 1, opacity: 0.8 },
                  hover: { scale: 1.2, opacity: 1 },
                }}
                className="absolute top-4 right-4 bg-white/90 backdrop-blur-md rounded-full p-2 shadow-md"
              >
                <Plus size={12} />
              </motion.div>

              {/* Contenido */}
              <div className="p-5 space-y-3">
                {/* Tipo + Tag */}
                <div className="flex gap-2 flex-wrap">
                  {item.field_programa && (
                    <span className="text-xs bg-gray-100 px-2 py-1 rounded">
                      {item.field_programa}
                    </span>
                  )}

                  {item.field_tag?.[0] && (
                    <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">
                      {item.field_tag}
                    </span>
                  )}
                </div>

                <h3 className="text-lg font-bold leading-tight">
                  {item.title}
                </h3>

                {modalidad && (
                  <p className="text-sm text-gray-600 leading-none p-0">
                    <strong>Modalidad:</strong> {getValue(modalidad)}
                  </p>
                )}

                <p className="text-sm text-gray-600 leading-none p-0">
                  <strong>Duración:</strong> 1 año
                </p>

                {campo && (
                  <p className="text-sm text-gray-600 leading-none p-0">
                    <strong>Campo del conocimiento:</strong> {getValue(campo)}
                  </p>
                )}

                {item.field_area && (
                  <p className="text-sm text-gray-600 leading-none p-0">
                    <strong>Facultad:</strong> {getValue(item.field_area)}
                  </p>
                )}
                {item.field_inicio?.[0] && (
                  <p className="text-sm text-gray-600 p-0 leading-none">
                    <b>Inicio de clases:</b> {item.field_inicio}
                  </p>
                )}
              </div>

              {/* Overlay */}
              <motion.div
                variants={{
                  rest: { opacity: 0 },
                  hover: { opacity: 1 },
                  tap: { opacity: 1 },
                }}
                className="absolute inset-0 bg-black/10 flex items-center justify-center"
              >
                <ArrowRight size={44} className="text-white" />
              </motion.div>
            </motion.a>
          );
        })}
      </div>
    </div>
  );

  return (
    <DataFetcherTemplate url="https://utpl.edu.ec/maestrias/services/escuela-negocios.json">
      {(data) => <DataDisplayOferta data={data} />}
    </DataFetcherTemplate>
  );
}

export default OfferEdes;
